__turbopack_context__.v({
  "dot": "DotsLoader-module__NJK7Yq__dot",
  "loader": "DotsLoader-module__NJK7Yq__loader",
  "wave": "DotsLoader-module__NJK7Yq__wave",
});
